/**
 * @file DetailsPanel.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of languages to manage language details
 */
import React from "react";
import { Box } from "@mui/material";

export const DetailsPanel = () => {
  return (
    <Box
      flex={1}
      height="100%"
      borderRadius="12px"
      px="8px"
      py={3}
      bgcolor="#F7F7F7"
      display={{ xs: "none", md: "flex" }}
      flexDirection="column"
    />
  );
};
